import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  IconButton,
  Link,
  Checkbox,
  Divider,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ShareIcon from '@mui/icons-material/Share';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

const ProductCard = ({ product }) => {
  const [quantity, setQuantity] = useState(1);

  const mockProduct = {
    title: "Instant Pot Pro 10-in-1 Pressure Cooker, Slow Cooker, Rice/Grain Cooker, Steamer, Sauté, Sous Vide, Yogurt Maker, Sterilizer, and Warmer, Includes App With Over 800 Recipes",
    price: 149.99,
    inStock: true,
    style: "Non-Wi-fi",
    color: "Black",
    size: "6 Quarts",
    image: "https://rembrandt.ownit.co/bbe7f343-989d-4045-9cf5-e240f261476e.jpg?width=768&bgcolor=white&format=jpeg&quality=65",
  };

  return (
    <Box sx={{ maxWidth: '1500px', mx: 'auto', p: 2 }}>
      {/* Shopping Cart Header */}
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 400 }}>
        Shopping Cart
        <Typography 
          component="span" 
          sx={{ 
            float: 'right', 
            color: '#565959',
            fontSize: '14px',
            mt: 2
          }}
        >
          Price
        </Typography>
      </Typography>

      <Divider sx={{ mb: 2 }} />

      {/* Product Card */}
      <Card sx={{
        width: '100%',
        boxShadow: 'none',
        mb: 2,
        borderBottom: '1px solid #DDD',
      }}>
        <CardContent sx={{ 
          display: 'flex', 
          p: 2,
          '&:last-child': { pb: 2 }
        }}>
          {/* Product Image */}
          <CardMedia
            component="img"
            sx={{
              width: 180,
              height: 180,
              objectFit: 'contain',
            }}
            image={mockProduct.image}
            alt={mockProduct.title}
          />

          {/* Product Details */}
          <Box sx={{ flex: 1, ml: 2 }}>
            <Typography variant="h6" sx={{ 
              fontSize: '18px',
              fontWeight: 400,
              mb: 0.5,
              color: '#0F1111'
            }}>
              {mockProduct.title}
            </Typography>

            {mockProduct.inStock ? (
              <Typography sx={{ 
                color: '#007600',
                fontSize: '14px',
                mb: 1
              }}>
                In Stock
              </Typography>
            ) : null}

            <Box sx={{ 
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 1,
              fontSize: '14px'
            }}>
              <Typography sx={{ color: '#565959' }}>
                Style: {mockProduct.style}
              </Typography>
              <Typography sx={{ color: '#565959' }}>
                Color: {mockProduct.color}
              </Typography>
              <Typography sx={{ color: '#565959' }}>
                Size: {mockProduct.size}
              </Typography>
            </Box>

            {/* Gift Option */}
            <Box sx={{ mb: 2 }}>
              <Checkbox 
                size="small"
                sx={{ p: 0, mr: 1 }}
              />
              <Typography 
                component="span" 
                sx={{ 
                  fontSize: '14px',
                  color: '#565959'
                }}
              >
                This is a gift
              </Typography>
              <Link 
                href="#" 
                sx={{ 
                  ml: 1,
                  fontSize: '14px',
                  color: '#007185',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#C7511F',
                    textDecoration: 'underline'
                  }
                }}
              >
                Learn more
              </Link>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ 
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              {/* Quantity Selector */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #DDD',
                borderRadius: 1,
                px: 1,
              }}>
                <select
                  value={quantity}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                  style={{
                    border: 'none',
                    padding: '5px',
                    width: '60px',
                    outline: 'none'
                  }}
                >
                  {[...Array(30)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </Box>

              <Divider orientation="vertical" flexItem />
              
              <Link 
                href="#"
                sx={{ 
                  color: '#007185',
                  textDecoration: 'none',
                  fontSize: '14px',
                  '&:hover': {
                    color: '#C7511F',
                    textDecoration: 'underline'
                  }
                }}
              >
                Delete
              </Link>

              <Divider orientation="vertical" flexItem />

              <Link 
                href="#"
                sx={{ 
                  color: '#007185',
                  textDecoration: 'none',
                  fontSize: '14px',
                  '&:hover': {
                    color: '#C7511F',
                    textDecoration: 'underline'
                  }
                }}
              >
                Save for later
              </Link>

              <Divider orientation="vertical" flexItem />

              <Link 
                href="#"
                sx={{ 
                  color: '#007185',
                  textDecoration: 'none',
                  fontSize: '14px',
                  '&:hover': {
                    color: '#C7511F',
                    textDecoration: 'underline'
                  }
                }}
              >
                Compare with similar items
              </Link>

              <Divider orientation="vertical" flexItem />

              <Link 
                href="#"
                sx={{ 
                  color: '#007185',
                  textDecoration: 'none',
                  fontSize: '14px',
                  '&:hover': {
                    color: '#C7511F',
                    textDecoration: 'underline'
                  }
                }}
              >
                Share
              </Link>
            </Box>
          </Box>

          {/* Price */}
          <Typography variant="h6" sx={{ 
            ml: 2,
            fontWeight: 700,
            color: '#0F1111'
          }}>
            ${mockProduct.price}
          </Typography>
        </CardContent>
      </Card>

      {/* Subtotal */}
      <Box sx={{ 
        textAlign: 'right',
        mb: 2
      }}>
        <Typography variant="h6">
          Subtotal (1 item): ${mockProduct.price}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProductCard; 